import { FC, useContext, useMemo } from "react";
import { TranslationScopes } from "@finbackoffice/enums";
import { LocaleContext, useRuntimeConfig } from "@finbackoffice/site-core";
import Img from "components/base/img/Img";
import Translate from "components/base/translate/Translate";
import Faq from "components/base/faq/Faq";
import styles from "../policies.module.sass";
import PoliciesCommonContent from "../PoliciesCommonContent";

const PoliciesCasino: FC = () => {
    const COMMON_SITE_CONFIGS = useRuntimeConfig("COMMON_SITE_CONFIGS");
    const ASSETS_URL = useRuntimeConfig("ASSETS_URL");
    const { locale } = useContext(LocaleContext);

    const faq = useMemo(() => {
        return [
            {
                id: "1",
                answer: {
                    dangerous: true,
                    replace: {
                        app_name: COMMON_SITE_CONFIGS.appName,
                    },
                },
            },
            {
                id: "2",
            },
            {
                id: "3",
                answer: {
                    dangerous: true,
                },
            },
            {
                id: "4",
                answer: {
                    replace: {
                        app_name: COMMON_SITE_CONFIGS.appName,
                    },
                },
            },
            {
                id: "5",
                answer: {
                    dangerous: true,
                    replace: {
                        app_name: COMMON_SITE_CONFIGS.appName,
                    },
                },
            },
            {
                id: "6",
                answer: {
                    replace: {
                        app_name: COMMON_SITE_CONFIGS.appName,
                    },
                },
            },
        ];
    }, [COMMON_SITE_CONFIGS.appName]);

    return (
        <PoliciesCommonContent
            translationKey="casino"
            translationScope={TranslationScopes.CasinoPolicies}
            headingIcon={{ width: 20, height: 18 }}
            wrapperClassName={styles.casino}>
            <Translate
                tid="casino_policies_headTxt"
                namespace={TranslationScopes.CasinoPolicies}
                dangerous
                replace={{
                    app_name: COMMON_SITE_CONFIGS.appName,
                }}>
                <div />
            </Translate>
            <Img
                source={`${ASSETS_URL}/common/desktop/social/live-casino-social-image-${locale}.webp`}
                alt="Evolution Xrp.bet Live Casino, Live Baccarat, Live Roulette, Live Blackjack cryptobetting"
                width={800}
                height={418}
                wrapperClassName={styles.bannerContainer}
            />
            <Faq
                namespace={TranslationScopes.CasinoPolicies}
                ids={faq}
                head={{
                    replace: {
                        app_name: COMMON_SITE_CONFIGS.appName,
                    },
                }}
            />
            <Img
                source={`${ASSETS_URL}/common/desktop/social/slot-social-image-${locale}.webp`}
                alt="Slots Xrp.bet, Pragmatic play winning slots crypto betting"
                wrapperClassName={styles.bannerContainer}
                width={800}
                height={418}
            />
        </PoliciesCommonContent>
    );
};

export default PoliciesCasino;
